import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, unref as _unref, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-71b23ad1"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "version-urchase" }
const _hoisted_2 = { class: "vu_wrap" }
const _hoisted_3 = { key: 1 }

import { ref } from 'vue';
import { useHomeStore } from '@/pinia/home';
import { Version, VersionRoleInfo } from './types';
import http from '@/api/account';
import { numberToCurrency } from '@/utils/format/number';
import CLoading from '@/components/CLoading.vue';
import oldVersion from './versionPage/OldVersion.vue';
import nextVersion from './versionPage/NextVersion.vue';


const __default__ = { name: 'version' };

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {

const showLoading = ref<boolean>(false);
const VERSION_VISIVLE = {
  OLD: false,
  NEXT: true,
};
const homeStore = useHomeStore();
// 旧版本变量
const versionArr = ref<Version[]>([]);
const versionList = ref<Version[]>([]);
// 新版本变量
const planList = ref<VersionRoleInfo[]>([]);
const tableList = ref<any[]>([]);
const tableKey = ref<any[]>([]);

const oldListFilter = (data: any) => {
  versionArr.value = data;
  const resData = data;
  resData.forEach((e: Version) => {
    if (e.role_info?.version_id !== 0) {
      e.role_info.price = numberToCurrency(e.role_info?.price as string);
      e.role_info.origin_price = numberToCurrency(e.role_info?.origin_price as string);
      versionList.value.push(e);
    }
  });
};

const status = ref(); // 1C   0T   版本
const nextListFilter = (data: any) => {
  const { key, list } = data;
  for (let i = 0; i < list.length; i++) {
    planList.value.push(list[i].role_info);
  }
  const resData = data.list;
  resData.forEach((e: Version) => {
    if (e.role_info?.version_id !== 0) {
      tableList.value.push(e);
    }
  });
  tableKey.value = Object.values(data.key);
  status.value = data.t_c_status;
};

const getVsersionList = () => {
  showLoading.value = true;
  http
    .getVsersionList({ params: { web_data: 1 } })
    .then((res) => {
      showLoading.value = false;
      // 新版本
      if (homeStore.isNewVersion === VERSION_VISIVLE.NEXT) {
        nextListFilter(res.data.data);
        return;
      }
      oldListFilter(res.data.data);
      // 旧版本
    })
    .catch((err) => {
      showLoading.value = false;
    });
};

getVsersionList();

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (showLoading.value)
        ? (_openBlock(), _createBlock(CLoading, { key: 0 }))
        : (_openBlock(), _createElementBlock("div", _hoisted_3, [
            (_unref(homeStore).isNewVersion === VERSION_VISIVLE.OLD)
              ? (_openBlock(), _createBlock(oldVersion, {
                  key: 0,
                  list: versionList.value,
                  arr: versionArr.value
                }, null, 8, ["list", "arr"]))
              : (_openBlock(), _createBlock(nextVersion, {
                  key: 1,
                  plan: planList.value,
                  list: tableList.value,
                  title: tableKey.value,
                  status: status.value
                }, null, 8, ["plan", "list", "title", "status"]))
          ]))
    ])
  ]))
}
}

})